var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({
    'background-color': _vm.$vuetify.theme.themes.dark.background,
    text: _vm.$vuetify.theme.themes.dark.text,
  })},[_c('v-main',[_c('v-fade-transition',{attrs:{"mode":"in-out"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }